import { favorite } from "../components/molecules/favorites";
export const getFavItem = (read) => {
    const favId = localStorage.getItem("favId");
    const favType = localStorage.getItem("favType");
    if (favId && favType) {
        favorite("", true, read, favId, favType, () => { }, "", true);
        localStorage.removeItem("favType");
        localStorage.removeItem("favId");
    }
};

